import { useEffect, useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";


gsap.registerPlugin(useGSAP);

export const useRefreshAnimation = ({
  isRefreshing,
}: {
  isRefreshing: boolean;
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const t1 = useRef<gsap.core.Timeline>();

  useGSAP(
    () => {
      t1.current = gsap
        .timeline({ paused: true, defaults: { ease: "linear" } })
        .to(".refresh-icon", {
          rotate: "360deg",
          duration: 1,
          repeat: -1,
        });
    },
    { scope: buttonRef }
  );

  useEffect(() => {
    if (t1?.current && isRefreshing) {
      // console.log("playing");
      t1.current.play();
    } else if (t1?.current && !isRefreshing) {
      t1.current.pause();
      // console.log("paused");
    }
  }, [isRefreshing]);

  return { buttonRef, t1 };
};
